import { Divider } from "@material-ui/core";
import React from "react";

import * as IconsSVG from "../../../../assets/iconsSVG";
import * as Styles from "./cardHistorico.styles";
import HistoricoAlteracao from "./components/historicosAlteracao.component";
import HistoricoEtapa from "./components/historicosEtapa.component";
import HistoricoOportunidade from "./components/historicosOportunidade.component";
import HistoricoTarefa from "./components/historicosTarefa.component";

interface Props {
  codigoTipoLogLead: string;
  idCorretorRealizacaoAcao: string;
  idLead: string;
  idLeadCorretor: string;
  idTipoLogLead: string;
  nome: string;
  valores: any;
  nomeCorretor: string;
  nomeFotoCorretor: string;
  dataAtualizacao: string;
  nomeStatusTarefa: string;
  nomeTipoTarefa: string;
  observacao: string;
  nomeMotivoDesqualificacaoLead: string;
  nomeCorretorDestino: string;
  resultado?: string;
  isTable?: boolean;
}

const CardHistorico: React.FC<Props> = ({
  idTipoLogLead,
  nome,
  valores,
  nomeCorretor,
  nomeFotoCorretor,
  dataAtualizacao,
  nomeStatusTarefa,
  nomeTipoTarefa,
  observacao,
  resultado,
  nomeMotivoDesqualificacaoLead,
  nomeCorretorDestino,
  isTable,
}) => {
  // const [title, setTitle] = useState<string>("Alteração!");

  return (
    <>
      <Styles.Container style={{ minHeight: isTable ? "auto" : 117 }}>
        <Styles.Header>
          <Styles.Title>{nome}</Styles.Title>
          <Styles.Date>{dataAtualizacao}</Styles.Date>
        </Styles.Header>
        <Styles.Body>
          {idTipoLogLead === "Alterações" && (
            <HistoricoAlteracao tipoAlteracao={nome} valores={valores} />
          )}
          {idTipoLogLead === "Alteracoes" && (
            <HistoricoAlteracao tipoAlteracao={nome} valores={valores} />
          )}
          {idTipoLogLead === "Etapa" && (
            // esse histórico é o de alteração, mas serve para etapas
            <HistoricoAlteracao tipoAlteracao={nome} valores={valores} />
          )}
          {idTipoLogLead === "Etiqueta" && (
            // esse histórico é o de alteração, mas serve para etapas
            <HistoricoAlteracao tipoAlteracao={nome} valores={valores} />
          )}
          {idTipoLogLead === "AtualizacaoLead" && (
            <HistoricoAlteracao tipoAlteracao={nome} valores={valores} />
          )}
          {idTipoLogLead === "Tarefas" && (
            <HistoricoTarefa
              nomeStatusTarefa={nomeStatusTarefa}
              nomeTipoTarefa={nomeTipoTarefa}
              observacao={observacao}
              resultado={resultado}
              dataAtualizacao={dataAtualizacao}
            />
          )}
          {idTipoLogLead === "Oportunidade" && (
            <HistoricoOportunidade valores={valores} />
          )}
          {idTipoLogLead === "Desqualificacao" && (
            <Styles.Text>Motivo: {nomeMotivoDesqualificacaoLead}</Styles.Text>
          )}
          {idTipoLogLead.normalize("NFD").replace(/[\u0300-\u036f]/g, "") ===
            "Transferencia" && (
            <>
              <Styles.Text>Transferido para: {nomeCorretorDestino}</Styles.Text>
              <Styles.Text>Motivo: {observacao}</Styles.Text>
            </>
          )}
          {idTipoLogLead === "Compartilhamento" && (
            <Styles.Text>Compartilhado com: {nomeCorretorDestino}</Styles.Text>
          )}
          {idTipoLogLead === "Exclusao" && (
            <Styles.Text>
              Exclusão compartilhamento com: {nomeCorretorDestino}
            </Styles.Text>
          )}
        </Styles.Body>
        {idTipoLogLead !== "Etapa" && (
          <>
            <Divider
              variant="middle"
              style={{ marginTop: 16, marginBottom: 16 }}
            />

            <Styles.Footer>
              {!nomeFotoCorretor || nomeFotoCorretor === "" ? (
                <Styles.AvatarBox>
                  <IconsSVG.UserIcon />
                </Styles.AvatarBox>
              ) : (
                <Styles.Img
                  width={25}
                  height={25}
                  style={{ borderRadius: 100, marginRight: 8 }}
                  src={nomeFotoCorretor}
                />
              )}

              <Styles.NomeCorretor>{nomeCorretor}</Styles.NomeCorretor>
            </Styles.Footer>
          </>
        )}
      </Styles.Container>
    </>
  );
};

export default CardHistorico;
